import { render } from "./PurchasePage.vue?vue&type=template&id=1c219a5c&scoped=true"
import script from "./PurchasePage.vue?vue&type=script&lang=js"
export * from "./PurchasePage.vue?vue&type=script&lang=js"

import "./PurchasePage.vue?vue&type=style&index=0&id=1c219a5c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c219a5c"]])

export default __exports__